/**
 * This is a best guess at getting the local domain that should be
 * used for cookies, while trying not to limit to an overly specific
 * subdomain.
 */
export const getLocalCookieDomain = function(global = window) {
  var localDomain = global.location.hostname;
  // So that we don't unnecessarily limit to subdomains,
  // drop any subdomains that are not 'stage', while handling
  // the case where we don't have a subdomain as well.
  const knownBFDomainDomains = [
    'buzzfeed',
    'buzzfeednews',
    'tasty',
    'huffpost',
    'huffingtonpost',
  ];
  const possibleSubDomain = localDomain.split('.')[0];
  if (
    possibleSubDomain &&
    possibleSubDomain !== 'stage' &&
    knownBFDomainDomains.indexOf(possibleSubDomain) === -1 &&
    localDomain.split('.').length >= 3
  ) {
    localDomain = localDomain.substring(possibleSubDomain.length + 1);
  }
  return localDomain;
};

/**
 * This should generally always be used as our source of truth domain.
 * The source of truth needs /destination-sync.html available at root,
 * and we should target the stage subdomain when on a non production
 * environment.
 */
export const getSourceOfTruthCookieDomain = function(env = 'dev') {
  if (env === 'dev') {
    return 'dev.buzzfeed.io';
  }

  return env === 'prod' || env === 'app-west' ?
    'buzzfeed.com' :
    'stage.buzzfeed.com';
};
